<div class="formContainer">
  <form [formGroup]="loginForm" (ngSubmit)="onSubmit(loginForm.value)"  >
    <label for="username">Username</label>
    <input id="username" type="text" formControlName="username">
    <label for="wachtwoord">Wachtwoord</label>
    <input id="wachtwoord" type="password" formControlName="wachtwoord">
    <button class="button" type="submit">Login</button>
    <div class="error vissible" *ngIf="showError !== undefined">{{showError}}</div>
  </form></div>
